import { SimTag } from "@/components/shared";

const TYPE_STYLES = {
  PURCHASE: { cls: "bg-[#14F195]/20 text-[#14F195]", dot: "#14F195" },
  ALLOCATION: { cls: "bg-[#9945FF]/20 text-[#9945FF]", dot: "#9945FF" },
  DISTRIBUTION: { cls: "bg-[#00F0FF]/20 text-[#00F0FF]", dot: "#00F0FF" },
  TREASURY: { cls: "bg-[#ffaa00]/20 text-[#ffaa00]", dot: "#ffaa00" },
};

export default function ActivityFeed({ items = [], compact = false }) {
  return (
    <div className="glass-panel rounded-2xl p-6" data-testid="ecosystem-activity-feed">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-sm font-semibold uppercase tracking-wider text-white mono-font">Recent Ecosystem Activity</h3>
        <SimTag>Simulated</SimTag>
      </div>
      <div className="relative">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-gradient-to-b from-[#9945FF]/40 via-[#00F0FF]/30 to-[#14F195]/20" />
        <div className={`space-y-4 ${compact ? "max-h-[340px]" : "max-h-[460px]"} overflow-y-auto pr-1`}>
          {items.map((a, i) => {
            const style = TYPE_STYLES[a.type] ?? TYPE_STYLES.TREASURY;
            return (
              <div key={i} className="flex gap-4 items-start group">
                <span className="relative z-10 mt-1.5 w-[15px] h-[15px] rounded-full border-2 shrink-0 transition-transform duration-300 group-hover:scale-125"
                  style={{ borderColor: style.dot, background: "#07050d", boxShadow: `0 0 8px ${style.dot}55` }} />
                <div className="flex-1 p-3 rounded-xl bg-black/40 border border-white/5 group-hover:border-[#9945FF]/30 transition-colors">
                  <div className="flex items-center gap-2 mb-1">
                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold mono-font ${style.cls}`}>{a.type}</span>
                    <span className="text-[10px] text-[#9b93b8] mono-font ml-auto">{a.minutes_ago}m ago</span>
                  </div>
                  <p className="text-xs text-[#d3cbef] mono-font leading-relaxed">{a.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <p className="text-[11px] text-[#ffaa00] mono-font mt-4">
        * Example activity only — no real transactions are executed and no real blockchain signatures exist yet.
      </p>
    </div>
  );
}
